import React from 'react';

import { TextField, Typography } from '@mui/material';

interface HeroEditorProps {
  title?: string;
  subtitle?: string;
  onPropChange: (key: string, value: any) => void;
}

const HeroEditor: React.FC<HeroEditorProps> = ({
  title,
  subtitle,
  onPropChange,
}) => {
  return (
    <>
      <Typography variant="h6">Content Options</Typography>
      <TextField
        label="Title (H1)"
        value={title || ''}
        onChange={(e) => onPropChange('title', e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Subtitle (H2)"
        value={subtitle || ''}
        onChange={(e) => onPropChange('subtitle', e.target.value)}
        fullWidth
        margin="normal"
      />
    </>
  );
};

export default HeroEditor;
